import React, { useCallback, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import slugify from "slugify";
import {
  Button,
  Form,
  Input,
  Modal,
  Space,
  Divider,
  Card,
  Row,
  Col,
  Switch,
  TreeSelect,
} from "antd";

import { AiFillCheckCircle, AiFillCloseSquare } from "react-icons/ai";

import { Editor } from "@tinymce/tinymce-react";
import ENV from "../../consts/config";
import FileChonky from "../../components/chonky/index";
import ReactDOM from "react-dom";
import products from "../../components/plugins/selectProduct";
import UploadFile from "../../components/UploadFile";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { fileManagerActions, systemActions } from "../../store";

import blogApi from "../../api/blog/blogApi";
import categoryApi from "../../api/blog/categoryApi";
import { list_to_tree } from "../../utils/index";
import ProductsModal from "../../components/ProductsModal";
import UpFileSingleProp from "../../components/UpFileSingleProp";

const ArticleAdd = (props) => {
  let navigate = useNavigate();
  const goToPreviousPath = () => {
    navigate(-1);
  };

  const back = () => {
    confirm({
      title: "Mọi chỉnh sửa sẽ bị mất ! Tiếp tục quay lại?",
      onOk() {
        goToPreviousPath();
      },
      onCancel() {},
    });
  };
  const { user: authUser } = useSelector((x) => x.auth);
  const dispatch = useDispatch();

  const { TextArea } = Input;
  const contentRef = useRef(null);
  const descriptionRef = useRef(null);

  const confirm = Modal.confirm;
  const [form] = Form.useForm();

  const [valueForm, setValueForm] = useState({
    title: null,
    published: true,
    slug: null,
    description: null,
    content: null,
    seoTitle: null,
    seoDescription: null,
    seoKeywords: null,
    avatar: null,
    category: null,
    productTitle: null,
    products: [],
    images: {
      image: null,
      key: null,
    },
  });
  const [treeLine, setTreeLine] = useState(true);
  const [showLeafIcon, setShowLeafIcon] = useState(false);
  const [categorySelect, setCategorySelect] = useState([]);
  const { fileImageUrl } = useSelector((x) => x.fileManager);

  const [listProductSelect, SetListProductSelect] = useState([]);

  const [image, setImage] = useState(null);

  useEffect(() => {
    getCategorySelect();
    form.setFieldsValue(valueForm);
    setImageNull(null);
  }, [valueForm]);

  const setLoading = (status) => {
    dispatch(systemActions.setLoadingSystem(status));
  };
  const setImageNull = (url) => {
    dispatch(fileManagerActions.setUrlImageUp(url));
  };
  const getCategorySelect = () => {
    setLoading(true);
    const params = { display: true, page: 1, limit: 10000 };
    categoryApi.getCategories(params).then((res) => {
      if (res) {
        const cate = res?.results.map((item) => {
          return {
            title: item.name,
            value: item.id,
            id: item.id,
            parentId: item.parent?.id || "0",
            parentName: item.parent?.name || "",
            children: null,
          };
        });
        const list = list_to_tree(cate);
        setCategorySelect(list);
        setLoading(false);
      }
      setLoading(false);
    });
  };

  const titleChange = useCallback(
    (values) => {
      const slug = slugify(values).toLowerCase();
      form.setFieldsValue({
        slug: slug,
      });
    },
    [form]
  );

  const [category, setCategory] = useState(null);

  const onChangeCategory = (newValue) => {
    setCategory(newValue);
  };

  const showBox = (callback, value, meta) => {
    const ModalFile = (props) => {
      const [show, setShow] = useState(true);
      const [image, setImage] = useState();
      useEffect(() => {}, []);
      const onSelected = (data) => {
        setImage(data);
      };
      const onAction = () => {
        document.querySelector(".tox .tox-dialog-wrap").style.display = "";
        ReactDOM.unmountComponentAtNode(props.modal);
      };
      return (
        <>
          <Modal
            title=""
            visible={show}
            width={1300}
            style={{ top: 20 }}

            onOk={() => {
              setShow(false);
              props.callback(`${ENV.CDN_URL}${image}`);
              onAction();
            }}
            okButtonProps={{
              disabled: !image,
            }}
            onCancel={() => {
              setShow(false);
              onAction();
            }}
            destroyOnClose={true}
          >
            {authUser ? (
              <div style={{ padding: "15px" }}>
                <style>
                  {`.ant-modal-wrap{
            z-index: 1300
          } .ant-image-preview-wrap{z-index: 1301}`}
                </style>
                <FileChonky onSelected={onSelected} />
                <br />
              </div>
            ) : null}
          </Modal>
        </>
      );
    };
    const modal = document.createElement("span");
    document.querySelector(".tox .tox-dialog-wrap").style.display = "none";
    ReactDOM.render(<ModalFile modal={modal} callback={callback} />, modal);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    if (category == null) {
      Swal.fire({
        title: "Thất bại!",
        text: "Vui lòng chọn chuyên mục!",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    createBlog(values);
  };

  const createBlog = (data) => {
    setLoading(true);

    let description = "";
    if (descriptionRef.current) {
      description = descriptionRef.current.getContent() || "";
    }

    let content,
      contentNonHtml = "";

    if (contentRef.current) {
      let _content = contentRef.current.getContent() || "";

      if (_content !== "") {
        _content = _content.replaceAll(
          `${ENV.CDN_URL}`,
          `${ENV.IMAGE_VARIABLE}`
        );
      }

      let _contentNonHtml =
        contentRef.current.getContent({ format: "text" }) || "";

      if (_contentNonHtml !== "") {
        _contentNonHtml = _contentNonHtml.replaceAll(
          `${ENV.CDN_URL}`,
          `${ENV.IMAGE_VARIABLE}`
        );
      }

      content = _content;
      contentNonHtml = _contentNonHtml;
    }

    const payload = {
      title: data.title,
      published: data.published,
      slug: data.slug,
      description: description,
      seoImage : image,
      seoTitle: data.seoTitle,
      seoDescription: data.seoDescription,
      seoKeywords: data.seoKeywords,
      content: content,
      contentNonHtml: contentNonHtml,
      avatar: fileImageUrl,
      category: category,
      productTitle: data.productTitle,
      products: listProductSelect,
    };

    blogApi.createBlog(payload).then(
      (res) => {
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Tạo thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setLoading(false);
          goToPreviousPath();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        setLoading(false);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const onSelectProducts = (data) => {
    const _data = data.map((item) => {
      return item.id;
    });

    SetListProductSelect(_data);
  };


  const onUploadImage = (url) => {
    setImage(url);
  };

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col span={24} md={24} className="mb-24">
          <Card
            className="header-solid h-full"
            bordered={false}
            title={<h6 className="font-semibold m-0">Thêm bài viết mới</h6>}
            extra={
              <>
                <Space>
                  <Button
                    type="primary"
                    icon={<AiFillCheckCircle />}
                    onClick={() => {
                      form.submit();
                    }}
                  >
                    &nbsp;Lưu
                  </Button>

                  <Button
                    type="danger"
                    icon={<AiFillCloseSquare />}
                    onClick={() => {
                      back();
                    }}
                  >
                    &nbsp;Hủy
                  </Button>
                </Space>
              </>
            }
            bodyStyle={{ paddingTop: "0" }}
          >
            <Divider />
            <Form
              form={form}
              initialValues={valueForm}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              labelCol={{
                span: 2,
              }}
              layout="horizontal"
              size="large"
            >
              <Form.Item
                tooltip="Trạng thái đăng tải của bài viết"
                label="Published"
                name="published"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <label>
                    <span style={{ color: "#ff4d4f" }}>*</span> Chuyên mục
                  </label>
                }
              >
                <TreeSelect
                  treeLine={
                    treeLine && {
                      showLeafIcon,
                    }
                  }
                  style={{
                    width: "100%",
                  }}
                  dropdownStyle={{
                    maxHeight: 400,
                    overflow: "auto",
                  }}
                  treeData={categorySelect}
                  onChange={onChangeCategory}
                  placeholder="Chọn chuyên mục"
                />
                <br />
              </Form.Item>

              <Form.Item
                label="Tên bài viết"
                name="title"
                tooltip="Tên hiển thị của bài viết"
                onChange={(e) => {
                  titleChange(e.target.value);
                }}
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Slug"
                name="slug"
                rules={[
                  {
                    pattern: new RegExp(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
                    message: "Slug không đúng định dạng!",
                  },
                  {
                    required: true,
                    message: "Thiếu dữ liệu!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item>
                <Row>
                  <Col span={8}>
                    <Form.Item
                      label="Ảnh đại diện"
                      tooltip="Ảnh hiển thị trên website"
                    >
                      <UploadFile />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      label="Ảnh Thumbnail"
                      tooltip="Ảnh hiển thị trên social"
                    >
                      <UpFileSingleProp
                        onUploadImage={onUploadImage}
                        image={image}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item label="Thẻ tiêu đề" name="seoTitle">
                <Input />
              </Form.Item>

              <Form.Item label="Mô tả meta" name="seoDescription">
                <TextArea rows={4} />
              </Form.Item>

              <Form.Item label="Từ khóa meta" name="seoKeywords">
                <Input />
              </Form.Item>

              <Form.Item
                label="Mô tả ngắn"
                tooltip="Mô tả rút gọn của bài viết"
              >
                <Editor
                  tinymceScriptSrc={
                    process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"
                  }
                  onInit={(evt, editor) => (descriptionRef.current = editor)}
                  // initialValue=""
                  init={{
                    height: 300,
                    menubar: false,
                    language: "vi",
                    plugins: [
                      "advlist",
                      "autolink",
                      "lists",
                      "link",
                      "charmap",
                      "preview",
                      "anchor",
                      "searchreplace",
                      "visualblocks",
                      "code",
                      "fullscreen",
                      "insertdatetime",
                      "media",
                      "table",
                      "help",
                      "wordcount",
                    ],
                    // apiKey: "5GMJDFLT",
                    toolbar:
                      "undo redo | blocks | " +
                      "bold italic forecolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                />
              </Form.Item>

              <Form.Item label="Nội dung" tooltip="Nội dung của bài viết">
                <Editor
                  tinymceScriptSrc={
                    process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"
                  }
                  onInit={(evt, editor) => (contentRef.current = editor)}
                  // initialValue=""
                  init={{
                    height: 600,
                    menubar: true,
                    image_title: true,
                    file_picker_callback: showBox,
                    file_picker_types: "image",
                    language: "vi",
                    plugins: [
                      "advlist",
                      "autolink",
                      "lists",
                      "link",
                      "image",
                      "charmap",
                      "preview",
                      "anchor",
                      "searchreplace",
                      "visualblocks",
                      "code",
                      "fullscreen",
                      "insertdatetime",
                      "media",
                      "table",
                      "help",
                      "wordcount",
                      "myCustomToolbarButton",
                    ],
                    setup: function (options) {
                      window.tinymce.PluginManager.add(
                        "myCustomToolbarButton",
                        products
                      );
                    },
                    toolbar:
                      "undo redo | productButton | link image | blocks | " +
                      "bold italic forecolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                    extended_valid_elements: "product[id]",
                    custom_elements: "product",
                    object_resizing: ":not(.iframe-product)",
                  }}
                />
              </Form.Item>

              <Form.Item
                label="Tiêu đề sản phẩm"
                name="productTitle"
                tooltip="Tiêu đề hiển thị trên danh sách sản phẩm"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Sản phẩm"
                tooltip="Sản phẩm hiển thị cùng bài viết"
                name="products"
              >
                <ProductsModal
                  productItems={[]}
                  onSelectProducts={onSelectProducts}
                />
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ArticleAdd;
